// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Delivery20FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Delivery20Filled: FC<Delivery20FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M5 16.25a2.411 2.411 0 0 1-1.77-.73 2.41 2.41 0 0 1-.73-1.77H1v-8.5c0-.412.147-.766.44-1.06.294-.293.647-.44 1.06-.44H14v3h2.5l2.5 3.5v3.5h-1.5c0 .694-.243 1.285-.73 1.77a2.411 2.411 0 0 1-1.77.73 2.411 2.411 0 0 1-1.77-.73 2.411 2.411 0 0 1-.73-1.77h-5a2.41 2.41 0 0 1-.73 1.77 2.411 2.411 0 0 1-1.77.73Zm0-1.5c.283 0 .52-.096.713-.287A.968.968 0 0 0 6 13.75a.968.968 0 0 0-.287-.713A.967.967 0 0 0 5 12.75a.967.967 0 0 0-.713.287.968.968 0 0 0-.287.713c0 .283.096.52.287.713.192.191.43.287.713.287Zm10 0c.283 0 .52-.096.713-.287A.968.968 0 0 0 16 13.75a.968.968 0 0 0-.287-.713.968.968 0 0 0-.713-.287.968.968 0 0 0-.713.287.968.968 0 0 0-.287.713c0 .283.096.52.287.713.192.191.43.287.713.287Zm-1-4h3.5l-1.77-2.5H14v2.5Z" />
        </svg>
    );
};

export default Delivery20Filled;
